export default "__VITE_ASSET__D6M7fE6l__"